import React from "react";
import { Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { Button } from "@/components";
import { AuthForm } from "../../Forms";
import { AuthLine } from "../AuthLine";
import { AuthLinks } from "../AuthLinks";
import { useModalNavigation } from "../../hooks/useModalNavigation";
import { useAppSelector } from "@/redux/store";
import { closeModal } from "react-url-modal";
import styles from "./AuthModal.module.scss";
import guestIcon from "@/assets/icons/questIcon.svg";

interface AuthModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

export const AuthModal: React.FC<AuthModalProps> = ({ isOpen, setIsOpen, onClose }) => {
  const { handleChangePass, handleRegister } = useModalNavigation();
  const { auth, isLoading } = useAppSelector(state => state.authAndReg);
  const hasClosedRef = React.useRef(false);

  React.useEffect(() => {
    if (auth && !isLoading && !hasClosedRef.current && isOpen) {
      hasClosedRef.current = true;
      const timer = setTimeout(() => {
        closeModal();
      }, 200);
      
      return () => clearTimeout(timer);
    }
    
    if (!isOpen) {
      hasClosedRef.current = false;
    }
  }, [auth, isLoading, isOpen]);

  return (
    <Modal
      title={ModalTexts.auth.authStart.TITLE}
      subTitle={ModalTexts.auth.authStart.SUB_TITLE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={onClose}
      mobileContentSize="full-screen-page-header"
    >
      <AuthForm handleChangePass={handleChangePass} />

      <AuthLine />

      <Button newStyles={styles.button} onClickFunc={onClose}>
        <img src={guestIcon} alt="guest icon" />
        <span>
          Продолжить как гость
        </span>
      </Button>

      <AuthLinks
        text="Еще нет аккаунта?"
        linkText="Регистрация"
        onLinkClick={handleRegister}
      />
    </Modal>
  );
};

